'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("mktIndexationsPage", {
  bindings: {},
  template: require("./mktIndexations.html"),
  controller: function controller($scope, $translate, $authz) {
    var tabs = [];
    tabs.push({
      title: $translate('marche.history.indexations.IndexationsPersonnalisees'),
      fragment: "indexationsPersonnalisees",
      template: require('./indexationsPersonnalisees/indexationsPersonnalisees.html'),
      controller: "IndexationsPersonnaliseesController",
      invalidable: true
    });
    $scope.indexationsTabConfig = {
      tabsetClass: "reporting-tabs",
      pillsClass: "",
      tabParameter: "subsection",
      tabs: tabs
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/indexations/mktIndexations.js
// module id = 2852
// module chunks = 13